import { graphql } from 'src/graphql';

export const BookingTaskResults = graphql(`
  query BookingTaskResults($_booking_id: ObjectID!) {
    participantBookingTaskResults(_booking_id: $_booking_id) {
      nodes {
        _id
        _task_id
        status
        task_started
        task_loaded
        task_ended
        details {
          type

          ... on BookingTaskResultDetailsFigmaPrototype {
            path {
              node_id
              started
              ended
              clicks
              misclicks
            }
          }

          ... on BookingTaskResultDetailsMultipleChoiceQuestion {
            answers {
              _id
              value
            }
            other_answer
          }

          ... on BookingTaskResultDetailsOpenAnswer {
            response
          }

          ... on BookingTaskResultDetailsFileUpload {
            filename
            mime_type
            size
            upload_path
          }

          ... on BookingTaskResultDetailsOpinionScale {
            answer
            answer_normalised
          }

          ... on BookingTaskResultDetailsStackRank {
            items {
              _id
              rank
            }
          }

          ... on BookingTaskResultDetailsTreeTest {
            outcome_type
          }
        }
      }
    }
  }
`);
